export default __webpack_public_path__ + "static/media/Fairmont Hotel.2cfe406d.jpg";